import { LoginErrorCode } from '@estercare/ester-shared'

// The Auth0 callback failed. Unlike the codes in LoginErrorCode, it does not come from the API
export const SSO_LOGIN_FAILED = 'SSO_LOGIN_FAILED'

const LOGIN_ERROR_CODES: string[] = Object.values(LoginErrorCode)

export const isLoginErrorCode = (value: unknown): value is LoginErrorCode =>
  typeof value === 'string' && LOGIN_ERROR_CODES.includes(value)
